export const CulturespacesThemePreset = {
  semantic: {
    primary: {
      50: '#E5ECFA',
      100: '#99B4E8',
      200: '#698EDA',
      300: '#3B68CA',
      400: '#2453C2',
      500: '#0B3CB9', //main color
      600: '#062A89',
      700: '#042171',
      800: '#02195B',
      900: '#011146',
      950: '#010A31'
    },
    colorScheme: {
      light: {
        primary: {
          color: "{primary.500}",
          contrastColor: "{surface.0}",
          hoverColor: "{primary.600}",
          activeColor: "{primary.700}",
          gradient: "45deg, {primary.300} 0%, {primary.500} 49.5%, {primary.300} 100%",
          shadow: "0px 5px 20px -5px {primary.600}",
        }
      }
    }
  }
}